import React, { Component } from 'react';
import '../myutils';
import {
  required, 
  SimpleForm,
  TextInput,
  translate,
} from 'react-admin'; 
import BookIcon from '@material-ui/icons/Book'; 
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import { configAPI } from '../config'
import Rename from '@material-ui/icons/TextFormat';
import { Tooltip } from '@material-ui/core';
import { push as pushAction } from 'react-router-redux';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogActions from '@material-ui/core/DialogActions';

export const TemplateIcon = BookIcon;

class RenameFile extends Component {

  state = {
    open: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      record: false,
      fileName: '',
      fileExt: '',
      openReplaceDialog: false
    }

  }

  handleClickOpen = (e) => {
    e.stopPropagation();
    this.setState({ open: true });
    let name = this.props.record.name.split('.');
    this.setState({ fileName: name[0] });
    this.setState({ fileExt: name[1] });
  };

  handleClose = (e) => {
    e.stopPropagation();
    this.props.handleCloseMenu()
    this.setState({ open: false });
  };

  handleFileNameChange = (e) => {
    let fileName = e.target.value;
    this.setState({ fileName: fileName });
  };
  
  handleFileExtChange = (e) => {
    let fileExt = e.target.value;
    this.setState({ fileExt: fileExt });
  };

  handleCloseReplaeDialog = (e) => {
    (e !== undefined) && e.stopPropagation();
    this.setState({
      openReplaceDialog: false,
    });
  };

  checkFileNotExists(path, fileName) {
    if (path.indexOf('/'+fileName) > -1 )  {
      this.setState({ open: false });
      return false;
    }
    if ((sessionStorage.AllFiles.indexOf('/'+fileName) === -1)) {
      return true
    }
    else {
      this.setState({ openReplaceDialog: true })
      return false;
    }
  }

  handleSendSubmit = (e, approve=false) => {
    e.stopPropagation();
    
    const { fileName, fileExt } = this.state;
    const { push } = this.props;
    var request;
    var path = this.props.record.what;
    
    if (path === undefined) path = this.props.record.filterValues.path;
    if (approve) this.setState({ openReplaceDialog: false });
    if (this.checkFileNotExists(path,fileName+'.'+fileExt) || approve){
      if (fileExt!==''&&fileExt!==undefined) request = new Request(encodeURI(configAPI.api.prod + '/FileAction?token=' + sessionStorage.B.encodeDecode() + '&action=move&what=' +
        path.replace('ivr2:', 'ivr2:/') + '&target=' + path.substr(0, path.lastIndexOf("/") + 1) + fileName + '.' + fileExt));
      else request = new Request(encodeURI(configAPI.api.prod + '/FileAction?token=' + sessionStorage.B.encodeDecode() + '&action=move&what=' +
        path.replace('ivr2:', 'ivr2:/') + '&target=' + path.substr(0, path.lastIndexOf("/") + 1) + fileName));
      fetch(request)
        .then(response => response.json())
        .then(json => {

          if (json.responseStatus === 'OK') {
            json.reports.forEach(element => {
              var dPath = element.what.replace('ivr2:','');
              var nPath = element.target.replace('ivr2:','');
              sessionStorage.setItem('AllDirs', sessionStorage.AllDirs.replace(','+dPath,'')+nPath+',');
            });

            this.props.handleCloseMenu(e);
            push('/IVR?');
            push('/IVR?filter=' + sessionStorage.Filter);
          }
        });
      }
  }

  render() {
    const { translate } = this.props;
    return (
      <Tooltip title={translate(`trans.renamefile`)}>
        <IconButton onClick={(e) => this.handleClickOpen(e)} >
          <Rename />
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="form-dialog-title"
            onBackdropClick={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
          >
            <IconButton color="inherit" onClick={(e) => this.handleClose(e)} aria-label="Close" style={{ float: 'right' }}>
              <CloseIcon />
            </IconButton>
            <SimpleForm
              toolbar={false}
              defaultValue={{ average_note: 0 }}>
              <TextInput source="fileName" onChange={(e) => this.handleFileNameChange(e)} onClick={(e) => e.stopPropagation()}
                validate={required()} label={translate(`trans.new_file_name`)} defaultValue={this.state.fileName} />
              {(this.state.fileExt!==''&&this.state.fileExt!==undefined)&&(<TextInput source="fileExt" onChange={(e) => this.handleFileExtChange(e)} onClick={(e) => e.stopPropagation()}
                label={translate(`trans.new_file_ext`)} defaultValue={this.state.fileExt} />)}
            </SimpleForm>
            <br></br>
            <DialogActions>
              <Button onClick={(e) => this.handleSendSubmit(e)} color="primary">
                {translate('ra.action.ok')}
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={this.state.openReplaceDialog}
            onClose={this.handleCloseReplaeDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle>
              {translate('trans.override')}
            </DialogTitle>

            <DialogActions>
              <Button onClick={(e) => this.handleCloseReplaeDialog(e)} color="primary">
                {translate(`trans.cancel`)}
              </Button>
              <Button onClick={(e) => this.handleSendSubmit(e, true)} color="primary" autoFocus>
                {translate(`trans.ok`)}
              </Button>
            </DialogActions>
          </Dialog>
          </IconButton>
      </Tooltip>
    );
  }
}


export default connect(null, {
  push: pushAction,
})(translate(RenameFile));
